import React from 'react'

import Header from '../../components/molecules/Header/Header'
import './404.css'

import {
  FourOhFourContainer,
  FourOhFourInnerContainer,
  FourOhFourTitle,
  FourOhFourSubTitle,
} from './404.css.js';

export default ({ config, content, props, siteUrl }) => {
  const { header } = content;
  
  return (
    <div>
      <Header
        {...header}
      />

      <main id="FourOhFour" className="FourOhFour">
        <div className="header-text">
          <FourOhFourContainer>
            <FourOhFourTitle>404</FourOhFourTitle>
            <FourOhFourSubTitle>The page you're looking for doesn't exist.</FourOhFourSubTitle>
          </FourOhFourContainer>
        </div>
      </main>
    </div>
  )
}
